import React, { useEffect, useReducer, useRef } from "react";
import { BrowserRouter, Route, Routes, useNavigate, useLocation, bro } from "react-router-dom";
import { AuthenticatedRoutes, UnAuthenticatedRoutes } from "./routes/index";
import { UserContext, WarehouseContext, AnalyticsContext } from "./storage/context/index";
import { ADD_ANALYTICS, ADD_USER_PROFILE } from "./storage/reducers/types";
import axiosInstance, { attachAxiosInterceptors } from "./api/axiosInstance";
import { changePage, trackEvent, updateAnalyics, VERIFY_EMAIL_FAILURE, VERIFY_EMAIL_SUCCESS } from "./analytics";
import "./App.scss";
import {
  DEFAULT_WAREHOUSE_STATE,
  warehouseReducer,
  USER_PROFILE_DEFAULT_STATE,
  userProfileReducer,
  analyticsReducer,
} from "./storage/reducers/index";

import { useToast } from "./hooks/useToast";
import { EMAIL_VERIFIED_LOGIN_SUCCESSFUL, EMAIL_VERIFIED_LOGIN_SUCCESSFUL_AUTO_LOGIN, TOKEN_EXPIRED } from "./constants/toastMessages";
import useProfile from "./hooks/useSetUserProfile";
import { message } from "antd";

function App() {
  const [warehouse, dispatchWarehouse] = useReducer(warehouseReducer, DEFAULT_WAREHOUSE_STATE);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { logoutUserProfile } = useProfile();
  const toast = useToast();

  let userRequestedLocation = useRef(useLocation().pathname);

  const [userProfile, dispatchUserProfile] = useReducer(userProfileReducer, USER_PROFILE_DEFAULT_STATE);
  const [userAuthenticated, setUserAuthenticated] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [analytics, dispatchAnalytics] = useReducer(analyticsReducer, JSON.parse(localStorage.getItem("phyllo_analytics")));

  // initializes page change tracker for the analytics
  useEffect(() => {
    changePage(location.pathname);
    // updateAnalyics(userProfile, dispatchAnalytics, warehouse.environment.current);
  }, [location]);

  // useEffect(() => {
  //   updateAnalyics(userProfile, dispatchAnalytics, warehouse.environment.current);
  // }, [warehouse.environment.current]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    updateAnalyics(userProfile, dispatchAnalytics, warehouse.environment.current);
    if (params.get("message") && params.get("success") === "true" && params.get("code") === "success") {
      if (user) {
        // If the session is opening in the same browser --> Auto login to dashboard will happen
        toast(EMAIL_VERIFIED_LOGIN_SUCCESSFUL_AUTO_LOGIN);
        user.emailVerified = true;
        localStorage.setItem("user", JSON.stringify(user));
        trackEvent(VERIFY_EMAIL_SUCCESS, { email: user.email });
      } else {
        // If the session is opening on a different browser/device --> Redirected to Sign-in page
        toast(EMAIL_VERIFIED_LOGIN_SUCCESSFUL);
        trackEvent(VERIFY_EMAIL_SUCCESS);
      }
    } else if (params.get("message") && params.get("success") === "false")
      trackEvent(VERIFY_EMAIL_FAILURE, { failure_reason: params.get("message") });

    // check if token got expired or not
    const time = new Date();
    if (user && new Date(user.tokenExpiry) < new Date(time.toISOString())) {
      localStorage.removeItem("user");
      logoutUserProfile();
    }
    // if it has expired, simply remove from local storage

    if (user) {
      dispatchUserProfile({ type: ADD_USER_PROFILE, payload: user });
      // adding response interceptor to axios instance
      attachAxiosInterceptors(toast, TOKEN_EXPIRED);
      axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${user.token}`;
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    const hasLoggedIn = !!userProfile.user.emailVerified && !!userProfile.user.token;

    setUserAuthenticated(hasLoggedIn);
  }, [userProfile.user]);

  if (loading) {
    // can return phyllo icon instead of null
    return null;
  }
  return (
    <UserContext.Provider value={{ userProfile, dispatchUserProfile }}>
      <WarehouseContext.Provider value={{ warehouse, dispatchWarehouse }}>
        <Routes>
          {userAuthenticated ? (
            <Route path="*" element={<AuthenticatedRoutes userRequestedLocation={userRequestedLocation.current} />} />
          ) : (
            <Route path="*" element={<UnAuthenticatedRoutes />} />
          )}
        </Routes>
      </WarehouseContext.Provider>
    </UserContext.Provider>
  );
}

export default App;
